// TRIL-420: live character counter copy for the draft editors.
// The floor values (minStoryLength / minReplyLength) come from the server via
// usePublishConstraints — no floor literal lives on the client.
export const charCounter = {
  loading: (n: number) => `${n.toLocaleString()} characters`,
  of: (n: number, min: number) =>
    `${n.toLocaleString()} / ${min.toLocaleString()} characters`,
  toGo: (remaining: number) => `${remaining.toLocaleString()} to go`,
  met: (n: number) => `✓ ${n.toLocaleString()} characters`,
  checking: 'Checking length requirements…',
  // Shown when the publishConstraints query fails: honest (not "checking") +
  // paired with a retry control in the draft components.
  loadError: "Couldn't load the length requirement.",
  retry: 'Retry',
};

export const POST = {
  CARD_EDITED_POST_TITLE: 'Changes',
  CLOSE_MODAL: 'Close',
  CANCEL: 'Cancel',
  CREATE_DRAFT: 'Create Draft',
  PUBLISH_DRAFT: 'Publish Draft',
  SAVE_POST: 'Save Post',
  DONE_EDITING: 'Done Editing',
  SAVE_CHANGES: 'Save Changes',
  EDIT_DRAFT: 'Edit Draft',
  REPLY: 'Reply',
  EDITED_MODAL: {
    TEXT_ADDED: 'Text Added',
    TEXT_REMOVED: 'Text Removed',
  },
};

export const DRAFT = {
  EDIT_DRAFT: 'Edit Draft',
  DELETE_DRAFT: 'Delete Draft',
  STATUS: {
    PUBLISHED: 'Published',
    UNPUBLISHED: 'Draft',
  },
};

export const POST_BUTTON_LABELS = {
  DONE_EDITING: 'Done Editing',
  REPLY: 'Reply',
  REPLIES: 'Replies',
};

// TRIL-353: max chars of a reply shown inline in the replies drawer before it's
// snipped (word boundary + "…") and a "View reply →" link takes over.
export const REPLY_DRAWER_PREVIEW_CHARS = 360;

export const PostBodyComponentConstants = {
  TEXT_AREA_NAME: 'body',
  TEXT_AREA_PLACEHOLDER: 'Start writing...',
  TEXT_AREA_TITLE_LC: 'title',
  TEXT_AREA_TITLE_UC: 'Title',
};
